import { makeStyles, Typography } from '@material-ui/core';
import React from 'react';

interface Props {
  readonly handleSelectAll: (e: any) => any;
  readonly handleClearAll: (e: any) => any;
}

export default function MenuHeader(props: Props) {
  const classes = useStyles();

  return (
    <div className={classes.menuHeaderContainer}>
      <Typography variant="body2" component="span" onClick={props.handleSelectAll} className={classes.menuHeaderLabel}>
        Select All
      </Typography>
      <Typography variant="body2" component="span" onClick={props.handleClearAll} className={classes.menuHeaderLabel}>
        Clear All
      </Typography>
    </div>
  );
}

const useStyles = makeStyles((theme: any) => ({
  menuHeaderContainer: { display: 'flex', justifyContent: 'space-between', padding: '12px 12px 0px 12px' },
  menuHeaderLabel: { cursor: 'pointer', color: theme.palette.primary.main },
}));
